import { useMemo } from 'react'

export function useLocaleDateFormat() {
  return useMemo(() => {
    const d = new Date()
    const fmt = new Intl.DateTimeFormat(Intl.DateTimeFormat().resolvedOptions().locale, {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    })
    const parts = fmt.formatToParts(d)
    return parts
      .map((p) => (p.type === 'day' ? 'dd' : p.type === 'month' ? 'MM' : p.type === 'year' ? 'yyyy' : p.value))
      .join('')
  }, [])
}
